import type {IssueEventInfo} from '@github-ui/dotcom-schema/types/pull_requests/v1/timeline'
import {Link} from '@github-ui/react-router'

export function ReferencedText({info}: {info: IssueEventInfo}) {
  const {commitAbbreviatedOid, commitRepositoryNameWithOwner, commitShortMessageText, commitUrl} = info

  if (!commitAbbreviatedOid || !commitUrl) {
    return <>referenced this pull request in a commit</>
  }

  return (
    <>
      referenced this
      {commitRepositoryNameWithOwner ? (
        <>
          {' from '}
          <strong>{commitRepositoryNameWithOwner}</strong>
        </>
      ) : null}
      {' in '}
      <Link className="color-fg-muted text-underline" to={commitUrl}>
        <code>{commitShortMessageText || commitAbbreviatedOid}</code>
      </Link>
    </>
  )
}
